import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import Button from '../Button';
import LocaleText from '../LocaleText';

class CheckoutPopup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: props.show,
        };

        this.onClick = this.onClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.show !== nextProps.show) {
            this.setState({ show: nextProps.show });
        }
    }

    onClick() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    render() {
        let output = (
            <span>
                <button className="checkout-popup__close" onClick={this.onClick}>
                    <Isvg src="/svg/cancel.svg" />
                </button>
                <div className="checkout-popup__wrapper">
                    <Isvg src="/svg/icon-attantion.svg" className="checkout-popup__icon" />
                    <h1>{this.props.title}</h1>
                    <div className="checkout-popup__inner">{this.props.children}</div>
                    <Button className="is-big" onClick={this.onClick}>
                        <LocaleText textKey="checkout.popup.cta" />
                    </Button>
                </div>
            </span>
        );

        if (this.props.plain) {
            output = <div className="checkout-popup__wrapper">{this.props.children}</div>;
        }

        return (
            <div
                className={`checkout-popup${this.props.invert ? ' is-inverted' : ''} ${
                    this.state.show ? 'is-on' : 'is-off'
                }`}
            >
                {output}
            </div>
        );
    }
}

CheckoutPopup.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClose: PropTypes.func,
    children: PropTypes.node,
    plain: PropTypes.bool,
    invert: PropTypes.bool,
};

export default CheckoutPopup;
